import gql from 'graphql-tag';

const GET_SIGN_IN_LOGO = gql`
  mutation getOrgLogo($domain: String!) {
    getOrgLogo(where: { domain: $domain })
  }
`;

export default GET_SIGN_IN_LOGO;
